var map = {
	"./configuration.ts": 36078,
	"./init.conf.ts": 28614,
	"./plugins/jquery.infoPage.ts": 54496,
	"./plugins/jquery.lastModifiedCheck.ts": 5598,
	"./plugins/jquery.lightbox.ts": 25810,
	"./selectorConfiguration.ts": 1237,
	"legacy/customer/allianz/configuration.ts": 36078,
	"legacy/customer/allianz/init.conf.ts": 28614,
	"legacy/customer/allianz/plugins/jquery.infoPage.ts": 54496,
	"legacy/customer/allianz/plugins/jquery.lastModifiedCheck.ts": 5598,
	"legacy/customer/allianz/plugins/jquery.lightbox.ts": 25810,
	"legacy/customer/allianz/selectorConfiguration.ts": 1237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31447;